import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { ProfilePage } from '~/features/account/profile-page';
import { DeleteAccountDialog } from '~/features/account/delete-account-dialog';

/** The confirm opens over Profile, as the canvas draws it; closing it goes back there. */
function DeleteAccountRoute(): ReactElement {
  return (
    <>
      <ProfilePage />
      <DeleteAccountDialog />
    </>
  );
}

export const Route = createFileRoute('/_app/account/delete')({
  component: DeleteAccountRoute,
});
